__turbopack_context__.v({
  "chartImg": "TestChartSection-module__2l0M-G__chartImg",
  "imgDesktop": "TestChartSection-module__2l0M-G__imgDesktop",
  "imgMobile": "TestChartSection-module__2l0M-G__imgMobile",
  "root": "TestChartSection-module__2l0M-G__root",
  "stickyWrapper": "TestChartSection-module__2l0M-G__stickyWrapper",
  "textContent": "TestChartSection-module__2l0M-G__textContent",
});
